import { render, staticRenderFns } from "./SpeedIcon.vue?vue&type=template&id=d5a67e00&scoped=true&"
import script from "./SpeedIcon.vue?vue&type=script&lang=js&"
export * from "./SpeedIcon.vue?vue&type=script&lang=js&"
import style0 from "./SpeedIcon.vue?vue&type=style&index=0&id=d5a67e00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a67e00",
  null
  
)

export default component.exports